import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-collapsed-card',
  templateUrl: './collapsed-card.component.html',
  styleUrl: './collapsed-card.component.scss'
})
export class CollapsedCardComponent {
  @Input({ required: true }) title: string;
  @Input() isCollapsed = false;
  @Input() canCollapse = true;
  @Input() headerClass = '';

  @Output() toggle = new EventEmitter<boolean>();

  get isCollapsedComputed() {
    return this.canCollapse ? this.isCollapsed : false;
  }

  onClick() {
    if (!this.canCollapse) return;
    this.isCollapsed = !this.isCollapsed;
    this.toggle.emit(!this.isCollapsed)
  }
}
